import { Component } from '@angular/core';
import { DisplayComponentInterface } from '@change-requests/interfaces/display-component.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'compensation-type-display-component',
    template: `
        <div>
            {{ getFormattedValue() }}
        </div>
    `,
})
export class CompensationTypeDisplayComponent implements DisplayComponentInterface {
    value = '';

    constructor(private translateService: TranslateService) {}

    getFormattedValue(): string {
        if (!this.value) {
            return '-';
        }

        return this.translateService.instant(`compensationTypes.${this.value}`) || '-';
    }
}
